import apiClient from "./apiClient";
import {
  getEmail,
  getOrgCode,
  getOrgName,
  getUserName,
} from "../components/shared/util";
const PEOPLE_PATH = "/api/v3/people";
export const getPeopleById = async (id) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/getDataByUserId`, {
    userId: id,
  });
  return response.data;
};

export const assignGolasInsidePeople = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/assignGoal`, {
    userId: data.userId,
    goal: data.goal,
    email: getEmail(),
  });
  return response.data;
};
export const shareBulkLearningPathForRecommendedJob = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/shareBulkLearningPathForRecommendedJob`,
    data,
  );
  return response.data;
};
export const shareLearningPathInsidePeople = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/shareBulkLearningPath`,
    data,
  );
  return response.data;
};
export const getSuggestedGoalsInsidePeople = async (userId) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/getRoleSuggestions`,
    userId,
  );
  return response.data;
};
export const deleteGoalInsidePeople = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/deleteGoal`, {
    goalId: data.goalId,
  });
  return response.data;
};

export const downloadLearningPathPdfApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/downloadLearningPath`,
    data,
    {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    },
  );
  return response; // ⬅️ return the whole response, not response.data
};

export const downloadLearningPathForRecommendedJobApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/downloadLearningPathForRecommendedJob`,
    data,
    {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    },
  );
  return response; // ⬅️ return the whole response, not response.data
};

export const editPeopleProfileApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/editPeopleProfile`, {
    ...data,
    email: getEmail(),
  });
  return response.data;
};

export const getAllPeopleApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/getAllPeople`, data);
  return response.data;
};
const buildPeopleQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      value === "All" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return;
    }

    if (Array.isArray(value)) {
      const cleaned = value.filter(
        (item) => item !== undefined && item !== null && item !== "",
      );

      if (!cleaned.length) return;

      if (key === "readiness") {
        searchParams.append(key, JSON.stringify(cleaned));
      } else {
        cleaned.forEach((item) => searchParams.append(key, item));
      }
      return;
    }

    searchParams.append(key, value);
  });

  return searchParams.toString();
};

export const getLeadershipNominationsApi = async (data = {}) => {
  const queryString = buildPeopleQueryString({
    pageSize: data.pageSize ?? 10,
    pageNo: data.pageNo ?? 1,
    search: data.searchFilter,
    seniority: data.level,
    sortBy: data.sortBy,
    readiness: data.type,
  });

  const response = await apiClient.get(
    `${PEOPLE_PATH}/getLeadershipNominations?${queryString}`,
  );

  return response.data;
};
export const deleteLeadershipNominationApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/deleteLeadershipNomination`,
    {
      nominationId: data.nominationId,
    },
  );
  return response.data;
};

const buildRecommendationsQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      const cleaned = value.filter(
        (item) => item !== undefined && item !== null,
      );

      if (key === "readiness") {
        searchParams.append(key, JSON.stringify(cleaned));
      } else {
        if (!cleaned.length) {
          searchParams.append(key, "");
          return;
        }

        cleaned.forEach((item) => searchParams.append(key, item));
      }
      return;
    }

    searchParams.append(key, value);
  });
  return searchParams.toString();
};

export const getMobilityRecommendationsApi = async (data) => {
  const queryString = buildRecommendationsQueryString({
    pageSize: data.pageSize,
    pageNo: data.pageNo,
    search: data.search,
    currentDepartment: data.currentDepartment,
    suggestedDepartment: data.suggestedDepartment,
    readiness: data.readiness,
    currentPosition: data.currentPosition,
    suggestedPosition: data.suggestedPosition,
    sortBy: data.sortBy,
  });
  const response = await apiClient.get(
    `${PEOPLE_PATH}/getMobilityRecommendations?${queryString}`,
  );
  return response.data;
};

export const getPeopleInviteLink = async (data) => {
  const response = await apiClient.get(
    `${PEOPLE_PATH}/generateInviteLink?department=${encodeURIComponent(data.department)}&userRole=${encodeURIComponent(data.userRole)}&educationLevel=${encodeURIComponent(data.educationLevel)}&fieldOfStudy=${encodeURIComponent(data.fieldOfStudy)}&section=${encodeURIComponent(data.section)}`,
  );
  return response.data;
};

export const sendReminderEmailApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/sendReminderEmail`,
    data,
  );
  return response.data;
};

export const removePeopleFromOrgApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/removePeopleFromOrg`,
    data,
  );
  return response.data;
};

export const getLearningDevelopmentDataApi = async (userId) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/getLearningDevelopmentData`,
    { userId: userId },
  );
  return response.data;
};

export const assignCourseApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/assignCourse`, {
    ...data,
  });
  return response.data;
};

export const deleteCourseApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/deleteCourse`, {
    ...data,
  });
  return response.data;
};

// GET PEOPLE CURRENT POSITIONS
export const currentPositionsApi = async () => {
  const response = await apiClient.get(
    `${PEOPLE_PATH}/getPeopleCurrentPositions`,
  );
  return response.data;
};
// api.js (same file; no extra utils)
export const downloadPeopleDataApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/downloadPeopleData`,
    data,
    {
      responseType: "blob",
      headers: {
        // ask for Excel, not PDF
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    },
  );

  // If the server returned JSON (error), surface it
  const contentType = response.headers?.["content-type"] || "";
  if (contentType.includes("application/json")) {
    const text = await response.data.text();
    const err = JSON.parse(text);
    throw new Error(err?.message || "Failed to download file");
  }

  // Try to extract a filename from Content-Disposition
  const cd = response.headers?.["content-disposition"];
  const getFileNameFromDisposition = (cdHeader) => {
    if (!cdHeader) return null;
    const star = cdHeader.match(/filename\*\s*=\s*[^']*'[^']*'([^;]+)/i);
    if (star?.[1]) return decodeURIComponent(star[1]);
    const plain = cdHeader.match(/filename\s*=\s*"?([^";]+)"?/i);
    if (plain?.[1]) return plain[1];
    return null;
  };

  const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
  const filename =
    getFileNameFromDisposition(cd) || `people-data-${timestamp}.xlsx`;

  // Ensure correct mime (some servers send octet-stream)
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);

  return true; // optional: lets the caller know it completed
};

export const bulkEditPeopleDepartmentApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/bulkEditPeopleDepartment`,
    data,
  );
  return response.data;
};

export const getMobilityOpportunitiesByUserldApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/getMobilityOpportunitiesByUserId`,
    data,
  );
  return response.data;
};

export const shareWithPartnersApi = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/shareWithPartners`,
    data,
  );
  return response.data;
};
